import { render, staticRenderFns } from "./GroupType.vue?vue&type=template&id=ecd21782&scoped=true"
import script from "./GroupType.vue?vue&type=script&lang=js"
export * from "./GroupType.vue?vue&type=script&lang=js"
import style0 from "./GroupType.vue?vue&type=style&index=0&id=ecd21782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd21782",
  null
  
)

export default component.exports